import { render, staticRenderFns } from "./KidneyCenters.html?vue&type=template&id=c9466932&"
import script from "./KidneyCenters.js?vue&type=script&lang=js&"
export * from "./KidneyCenters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports